import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4a0f87e6")

_pushScopeId("data-v-4a0f87e6")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_5 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "center" }, [
    /*#__PURE__*/_createVNode("th", null, "서브몰ID"),
    /*#__PURE__*/_createVNode("th", null, "파트너스명"),
    /*#__PURE__*/_createVNode("th", null, "결제금액"),
    /*#__PURE__*/_createVNode("th", null, "취소금액"),
    /*#__PURE__*/_createVNode("th", null, "예약매출"),
    /*#__PURE__*/_createVNode("th", null, "위약금매출"),
    /*#__PURE__*/_createVNode("th", null, [
      /*#__PURE__*/_createTextVNode("매출액"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("(결제-취소)"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("(예약+위약금)")
    ]),
    /*#__PURE__*/_createVNode("th", null, "수수료"),
    /*#__PURE__*/_createVNode("th", null, "정산금액"),
    /*#__PURE__*/_createVNode("th", null, "요청상태"),
    /*#__PURE__*/_createVNode("th", null, "지급일"),
    /*#__PURE__*/_createVNode("th", null, "지급요청일"),
    /*#__PURE__*/_createVNode("th", null, "메모")
  ])
], -1)
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = { class: "right" }
const _hoisted_11 = { class: "right" }
const _hoisted_12 = { class: "right" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createVNode("button", { class: "btn btn-primary" }, "추가", -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_18 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "center" }, [
    /*#__PURE__*/_createVNode("th", null, "결제일시"),
    /*#__PURE__*/_createVNode("th", null, "취소일시"),
    /*#__PURE__*/_createVNode("th", null, "결제수단"),
    /*#__PURE__*/_createVNode("th", null, "예약자명/인원"),
    /*#__PURE__*/_createVNode("th", null, "회원여부"),
    /*#__PURE__*/_createVNode("th", null, "결제금액"),
    /*#__PURE__*/_createVNode("th", null, "취소금액"),
    /*#__PURE__*/_createVNode("th", null, "결제-취소"),
    /*#__PURE__*/_createVNode("th", null, "수수료"),
    /*#__PURE__*/_createVNode("th", null, "정산금액"),
    /*#__PURE__*/_createVNode("th", null, "상품명")
  ])
], -1)
const _hoisted_19 = { class: "right" }
const _hoisted_20 = { class: "right" }
const _hoisted_21 = { class: "right" }
const _hoisted_22 = { class: "right" }
const _hoisted_23 = { class: "right" }
_popScopeId()

import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ApiService } from '@/services/backend-api/api.services';
import swal from '@/helper/swal.helper';
import { useStore } from 'vuex';
import { key } from '@/store';
import commerceUtil from '@/helper/commerceUtil';


export default _defineComponent({
  expose: [],
  setup(__props) {

const store = useStore(key);

const router = useRouter();
const route = useRoute();
const apiService = new ApiService();
const schedule = ref({});
const reservationList = ref([]);
const { id } = route.params;
const { date } = route.query;
const cancelReasonList = [
  {
    code: 'BAD_WEATHER',
    text: '기상악화',
  },
  {
    code: 'REPAIR_BOAT',
    text: '선박정비',
  },
  {
    code: 'UNDERMANNED',
    text: '출조인원 미달',
  },
];
const cancelDescriptionType = ref('');
onMounted(() => {
  getSchedule();
});

const getSchedule = async () => {
  store.commit('loading/showLoading', '데이터를 불러오는 중입니다.');
  const response = await apiService.get(
    `/v2/booking/provision/day/${date}/partners/${id}`,
  );
  console.log(response.data.item);
  schedule.value = response.data.item;
  reservationList.value = response.data.item.reservations;
  store.commit('loading/hideLoading');
};
const closeSchedule = async () => {
  swal.confirm(
    async () => {
      store.commit('loading/showLoading', '마감처리 중입니다.');
      const response = await apiService.post(
        '/booking-beta/reservation/offline',
        {
          schedule_data_id: id,
          name: '마감처리',
          cell_num: '',
          head_count: schedule.value.remaining_head_count,
          price: 0,
        },
      );
      store.commit('loading/hideLoading');
      if (response.status) {
        swal.success('마감처리 되었습니다.');
        getSchedule();
      } else {
        swal.alert(response.message);
      }
    },
    {
      title: '마감처리 하시겠습니까?',
      buttonText: '마감',
    },
  );
};
const openSchedule = async () => {
  swal.confirm(
    async () => {
      store.commit('loading/showLoading', '재오픈 처리중입니다.');
      const reservation = reservationList.value.find(
        item => item.name === '마감처리',
      );
      if (reservation) {
        const response = await apiService.delete(
          `/booking-beta/reservation/offline/${reservation.data_id}`,
        );
        store.commit('loading/hideLoading');
        if (response.status) {
          swal.success('재오픈되었습니다.');
          getSchedule();
        } else {
          swal.alert(response.message);
        }
      }
    },
    {
      title: '재오픈처리 하시겠습니까?',
      buttonText: '재오픈',
    },
  );
};
const cancelSchedule = async () => {
  if (!schedule.value.cancel_state_desc) {
    swal.alert('취소 사유가 선택되지 않았습니다.');
    return false;
  }
  swal.confirm(
    async () => {
      store.commit('loading/showLoading', '출조일정 취소 처리중입니다.');
      const response = await apiService.patch(`/booking-beta/schedule/${id}`, {
        cancel_description_type: schedule.value.cancel_state_desc,
      });
      if (response.status) {
        swal.success('출조일정이 취소되었습니다.');
        getSchedule();
      } else {
        swal.alert(response.message);
      }
      store.commit('loading/hideLoading');
    },
    {
      title: '출조일정을 취소하시겠습니까?',
      // text: '취소된 일정은 되돌릴 수 없습니다.',
      buttonText: '일정취소',
    },
  );
};
const back = () => {
  router.back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("table", _hoisted_4, [
          _hoisted_5,
          _createVNode("tbody", null, [
            _createVNode("tr", null, [
              _createVNode("td", null, _toDisplayString(schedule.value.toss_sub_mall_id), 1),
              _createVNode("td", null, _toDisplayString(schedule.value.partners_profile_nm), 1),
              _createVNode("td", _hoisted_6, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.value.payment_price)), 1),
              _createVNode("td", _hoisted_7, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.value.refund_price)), 1),
              _createVNode("td", _hoisted_8, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.value.reservation_sales_price)), 1),
              _createVNode("td", _hoisted_9, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.value.penalty_price)), 1),
              _createVNode("td", _hoisted_10, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.value.sales_price)), 1),
              _createVNode("td", _hoisted_11, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.value.fee)), 1),
              _createVNode("td", _hoisted_12, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.value.provision_price)), 1),
              _createVNode("td", null, _toDisplayString(schedule.value.provision_status_nm), 1),
              _createVNode("td", null, _toDisplayString(schedule.value.provisioned_at), 1),
              _createVNode("td", null, _toDisplayString(schedule.value.provision_req_at), 1),
              (schedule.value.memo)
                ? (_openBlock(), _createBlock("td", _hoisted_13, _toDisplayString(schedule.value.memo), 1))
                : (_openBlock(), _createBlock("td", _hoisted_14, [
                    _hoisted_15
                  ]))
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("table", _hoisted_17, [
          _hoisted_18,
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(schedule.value.reservations, (reservation) => {
              return (_openBlock(), _createBlock("tr", {
                key: schedule.value.data_id
              }, [
                _createVNode("td", null, _toDisplayString(reservation.payment_at), 1),
                _createVNode("td", null, _toDisplayString(reservation.refund_at), 1),
                _createVNode("td", null, _toDisplayString(reservation.payment_method_ko), 1),
                _createVNode("td", null, _toDisplayString(reservation.name) + " / " + _toDisplayString(reservation.head_count), 1),
                _createVNode("td", null, _toDisplayString(reservation.uid ? '회원' : '비회원'), 1),
                _createVNode("td", _hoisted_19, _toDisplayString(_unref(commerceUtil).getCurrency(reservation.payment_price)), 1),
                _createVNode("td", _hoisted_20, _toDisplayString(_unref(commerceUtil).getCurrency(reservation.refund_price)), 1),
                _createVNode("td", _hoisted_21, _toDisplayString(_unref(commerceUtil).getCurrency(reservation.sales_price)), 1),
                _createVNode("td", _hoisted_22, _toDisplayString(_unref(commerceUtil).getCurrency(reservation.fee)), 1),
                _createVNode("td", _hoisted_23, _toDisplayString(_unref(commerceUtil).getCurrency(reservation.provision_price)), 1),
                _createVNode("td", null, _toDisplayString(reservation.schedule_name), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})